<template>
  <div class="m-b-16">
    <!----招标单信息------>
    <div v-if="showOrder" class="card">
      <div class="section">
        <div class="section-title">
          <base-section-title title="招标单信息" />
        </div>
        <div class="section-content">
          <jczh-descriptions
            :info="orderInfo"
            :option="biddingInfoOption"
            :el-attrs="{
              size: 'medium',
              column: 3,
              labelStyle: {
                whiteSpace: 'nowrap'
              }
            }"
          >
            <template v-slot:budget="{ value }">
              <span>{{ value ? strToThousands(value) : '-' }} 万元</span>
              <money-in-cn :money="value * 10000" />
            </template>
          </jczh-descriptions>
        </div>
      </div>
    </div>

    <!---文件澄清--->
    <div class="card">
      <div class="section">
        <div class="section-title">
          <base-section-title title="文件澄清" />
        </div>
        <div class="section-content">
          <!---电子化开评标详情----->
          <bid-online-detail
            v-if="isKpbProject"
            class="online-file_inbox m-t-16"
            :kpb-file-id="kpbFileId"
            :order-id="orderId"
            :is-release="true"
          />
          <jczh-descriptions
            :info="clarificationInfo"
            :option="contentOptions"
            :el-attrs="{
              size: 'medium',
              column: 1,
              labelStyle: {
                width: '130px',
                whiteSpace: 'nowrap',
                textAlign: 'right'
              }
            }"
          >
            <template v-slot:fileGroupId>
              <upload-authorization-file
                v-if="clarificationInfo.fileGroupId"
                ref="UploadAuthorizationFile"
                v-model="clarificationInfo.fileGroupId"
                :preview-api="previewBiddingFileApi"
                :download-api="downloadBiddingFileApi"
                :request-params="{
                  isRelease: true,
                  orderId: orderId,
                  fileType: fileTypeDict.CLARIFY.value,
                  fileGroupId: clarificationInfo.fileGroupId,
                  supplementId: clarificationInfo.supplementId
                }"
                :props-data="{
                  disabled: true
                }"
              />
              <span v-else>-</span>
            </template>
            <template v-slot:supplementRemark>
              <u-editor disabled :value="clarificationInfo.supplementRemark" />
            </template>
          </jczh-descriptions>
        </div>
      </div>
    </div>

    <!-- 审批备注 -->
    <record-remark
      v-if="requestQuery.pageFrom == 'auditDetail'"
      :remark-list="remarkList"
    />

    <!-- 审批历史 -->
    <record-history
      v-if="requestQuery.pageFrom == 'auditDetail'"
      :record-list="orderInfo.flowListing"
    />
  </div>
</template>
<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import UEditor from '@/components/common/UEditor/index.vue'
import UploadAuthorizationFile from '@/components/common/Upload/UploadAuthorizationFile'
import MoneyInCn from '@/components/common/MoneyInCn'
import BidOnlineDetail from '@/components/kpb/project/BidOnlineDetail.vue'
import RecordHistory from '@/components/common/RecordHistory'
import RecordRemark from '@/components/common/RecordRemark'

import {
  projectTypeDict,
  releaseMediaDict,
  whetherDict,
  offerTypeDict
} from '@/dictionary/project/common'
import {
  needBidBondDict,
  bidWinWayDict,
  fileTypeDict,
  bondBidTypeDict
} from '@/dictionary/project/bid'

import {
  getClarificationByIdApi,
  getLastClarificationApi,
  fetchInviteBidDetailApi,
  previewBiddingFileApi,
  downloadBiddingFileApi
} from '@/api/procure/invite-bid'

import { strToThousands } from '@/utils/utils'
import DateUtils from '@/utils/date'
export default {
  components: {
    BaseSectionTitle,
    UEditor,
    UploadAuthorizationFile,
    MoneyInCn,
    BidOnlineDetail,
    RecordHistory,
    RecordRemark
  },

  props: {
    requestQuery: {
      type: Object,
      required: true
    },

    showOrder: {
      type: Boolean,
      default: true
    },

    isByOrderId: {
      type: Boolean,
      default: true
    },

    // 备注列表
    remarkList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  data() {
    return {
      fileTypeDict,
      bondBidTypeDict,

      previewBiddingFileApi,
      downloadBiddingFileApi,

      orderInfo: {},
      biddingInfoOption: [
        {
          label: '招标名称',
          prop: 'orderName',
          elAttrs: { span: 3 }
        },
        {
          label: '招标估算',
          prop: 'budget',
          // filter: value => `${value} 万元`
          slotName: 'budget'
        },
        {
          label: '中标方式',
          prop: 'winType',
          filter: value => bidWinWayDict.translate(value).label
        },
        {
          label: '报价方式',
          prop: 'offerType',
          filter: value => offerTypeDict.translate(value).label
        },
        {
          label: '报名时间',
          prop: '',
          filter: value => {
            return DateUtils.getNormMinuteRange(
              value.signUpStartTime,
              value.signUpEndTime
            )
          }
        },
        {
          label: '开标时间',
          prop: 'openTime',
          isNormMinute: true
        },
        {
          label: '项目类型',
          prop: 'biddingType',
          filter: value => projectTypeDict.translate(value).label
        },
        {
          label: '发布媒体',
          prop: 'noticeMedium',
          filter: value => {
            const temp = (value || '').split(',')
            return (
              temp
                .map(mediumValue => {
                  return releaseMediaDict.translate(mediumValue)?.label
                })
                .filter(value => value)
                .join('、') || '-'
            )
          }
        },
        {
          label: '招标地点',
          filter: value => {
            if (value?.country === '中国') {
              return `${value?.province} - ${value?.city} - ${value?.area}`
            } else {
              return `${value?.country} - ${value?.foreignAddress}`
            }
          }
        },
        {
          label: '详细地址',
          prop: 'detailAddress'
        }
      ],

      clarificationInfo: {},
      contentOptions: [
        {
          label: '开标时间',
          prop: 'openTime',
          isNormMinute: true
        },
        {
          label: '保证金缴纳截止时间',
          prop: 'depositEndTime',
          filter: value => {
            return DateUtils.getNormMinute(value)
          },
          hideFun: () =>
            this.orderInfo?.guarantee?.isCollectGuarantee ===
              needBidBondDict.NO.value ||
            this.orderInfo?.guarantee?.collectGuaranteeMode !=
              bondBidTypeDict.PLATFORM.value
        },
        {
          label: '澄清文件',
          prop: '',
          slotName: 'fileGroupId'
        },
        {
          label: '澄清声明',
          prop: '',
          slotName: 'supplementRemark'
        }
      ]
    }
  },

  computed: {
    orderId() {
      return this.requestQuery.orderId
    },
    // 是否是线上开评标项目
    isKpbProject() {
      return this.orderInfo.isKpbProject === whetherDict.YES.value
    },
    // 招标文件id
    kpbFileId() {
      return this.orderInfo?.biddingFileId || 0
    }
  },

  watch: {
    'requestQuery.orderInfo': {
      handler: function(val) {
        if (val) {
          this.orderInfo = this.requestQuery?.orderInfo || {}
        }
      },
      immediate: true
    },

    'requestQuery.orderId': {
      handler: function(val) {
        this.getClarification()
        if (this.isByOrderId && val) {
          this.getOrderInfo()
        }
      },
      immediate: true
    }
  },

  methods: {
    strToThousands,
    // 获取招标单详情信息
    async getOrderInfo() {
      if (!this.orderId) return
      try {
        const { data } = await fetchInviteBidDetailApi({
          orderId: this.orderId
        })
        this.orderInfo = data || {}
      } catch (error) {
        this.$message.error(error.message)
      }
    },

    /**
     * 获取澄清文件信息
     */
    getClarification() {
      if (!this.orderId) return
      if (this.requestQuery.supplementId) {
        this.getClarificationById()
      } else {
        this.getClarificationList()
      }
    },

    /**
     * 获取澄清文件列表
     */
    async getClarificationList() {
      try {
        const _data = await getLastClarificationApi(this.orderId)
        this.clarificationInfo = _data?.data || {}
        this.clarificationInfo.openTime = this.clarificationInfo?.afterChangeMap
          ? this.clarificationInfo?.afterChangeMap?.openTime
          : this.clarificationInfo.openTime
      } catch (error) {
        this.$message.error(error.message)
      }
    },

    /**
     * 通过澄清id获取招标澄清文件信息
     */
    async getClarificationById(supplementId = this.requestQuery.supplementId) {
      try {
        const { data } = await getClarificationByIdApi(
          this.orderId,
          supplementId
        )
        this.clarificationInfo = data || {}
        this.clarificationInfo.openTime = this.clarificationInfo?.afterChangeMap
          ? this.clarificationInfo?.afterChangeMap?.openTime
          : this.clarificationInfo.openTime
      } catch (error) {
        this.$message.error(error.message)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.online-file_inbox {
  width: 100%;
  background-color: $info-sixth-color;
  padding: 14px;
  border: 1px solid $dividing-color;
}
</style>
